import { useEffect, useState } from 'react'

import { Layout } from '@/Layout'
import { TeamMembers as MembersTemplate } from '@/templates/TeamMembers'

export const TeamMembers = () => {
  const [teamName, setTeamName] = useState<string>('')

  useEffect(() => {
    const storedTeamName = localStorage.getItem('teamName')
    if (storedTeamName) {
      setTeamName(storedTeamName)
      localStorage.removeItem('teamName')
    }
  }, [])

  return (
    <Layout
      title={teamName ? `${teamName}: Members` : 'Team Members'}
      showCreateButton={false}
      showBackButton
    >
      <MembersTemplate />
    </Layout>
  )
}
